<fieldset class="mb-4">
    <legend
        [id]="radioId()"
        [ngClass]="{
            'block text-base': true,
            'text-red-600': errorMessage.length > 0,
        }">
        <apcam-translation [model]="inputConfig.label" />
        {{ inputConfig.required ? ' *' : '' }}
    </legend>
    <mat-radio-group
        [attr.aria-labelledby]="radioId()"
        [formControlName]="formcontrolName"
        [required]="inputConfig.required">
        @for (
            option of inputConfig.options;
            track option.label.translations[defaultLang]
        ) {
            <mat-radio-button
                [value]="option.label.translations[defaultLang]"
                class="block">
                <apcam-translation [model]="option.label" />
            </mat-radio-button>
        }
    </mat-radio-group>
    @if (errorMessage.length > 0) {
        <p class="text-red-600">
            {{ errorMessage }}
        </p>
    }
</fieldset>
